import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";

export const fetchActivitiesList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/activities-activities-list`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};
